import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeader } from "./Shared";

const FAQS = [
  {
    q: "Are your Bursa signals Syariah compliant?",
    a: "Yes. Every Bursa Malaysia setup is screened against the Securities Commission Malaysia Syariah-compliant securities list before release. Syariah signals are included in all three tiers — Essential, Premium and VIP.",
  },
  {
    q: "How are signals delivered?",
    a: "Signals are pushed in real time via WhatsApp and Telegram with the exact entry price, stop-loss and target levels, plus position-sizing notes for your capital tier. VIP members additionally receive direct desk calls.",
  },
  {
    q: "What capital do I need to start?",
    a: "Essential requires a minimum of RM10,000, Premium RM30,000, and VIP RM100,000 or above. Targets scale with tier — from RM300–500 per trade on Essential up to RM5,000–10,000 on VIP.",
  },
  {
    q: "What is VIP account handling?",
    a: "VIP members may mandate our senior desk to execute and manage positions on their behalf, including IPO allocations and HSI momentum plays, with weekly performance reporting.",
  },
  {
    q: "Which markets are covered?",
    a: "All plans run across three desks: Bursa Malaysia (equities, FCPO, IPO), Forex & Comex (gold, major pairs, energy), and SGX & Nasdaq (including HSI for Premium and VIP tiers).",
  },
  {
    q: "Is trading profit guaranteed?",
    a: "No. Trading involves substantial risk and past performance does not guarantee future results. Our signals are research-based recommendations; you should only trade with capital you can afford to risk.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-line bg-surface/40 py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          align="center"
          eyebrow="FAQ"
          title="Answers before you commit capital."
        />

        <div className="mt-12 space-y-3">
          {FAQS.map((f, idx) => (
            <Reveal key={idx} delay={idx * 0.06}>
              <div
                data-testid={`faq-item-${idx}`}
                className={`overflow-hidden rounded-xl border transition-colors duration-300 ${
                  open === idx ? "border-alpha/50 bg-panel" : "border-line bg-surface"
                }`}
              >
                <button
                  data-testid={`faq-trigger-${idx}`}
                  onClick={() => setOpen(open === idx ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-base font-bold text-slate-100">{f.q}</span>
                  <Plus
                    size={18}
                    className={`shrink-0 text-gold transition-transform duration-300 ${open === idx ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === idx && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <p className="px-6 pb-6 text-sm leading-relaxed text-slate-400">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
